import React,{Component} from "react";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter, Alert } from "reactstrap";
import { renderField, renderCheckbox, required } from "../../../utils/formValidations.js";
import { connect } from "react-redux";
import { getLdap, updateLdap } from "../../../actions/actionLdap";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router-dom";
import Proptypes from "prop-types";
import { getLicenseStatus} from "../../../actions/actionFooter";

class LdapFormTemplate extends Component  {
    constructor(props){
        super(props);
        this.state  = {
            currentLdap: null,
            licensed: false,

        };
        this.submitLdap= this.submitLdap.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
        this.handleUpdateSuccess = this.handleUpdateSuccess.bind(this);
        this.handleCreateSuccess = this.handleCreateSuccess.bind(this);
        this.initializeForm = this.initializeForm.bind(this);
    }

    handleUpdateSuccess(){
        const {errorCreateMessage} = this.props;
        if(errorCreateMessage){
            NotificationManager.error(errorCreateMessage,"Update Ldap", 3000);        
        }
        else {
            NotificationManager.success("Ldap Update", "Ldap Updated Successfully");
            this.props.history.push("/ldap");
        }
    }

    handleUpdateError(){
        const {updateLdapError} = this.props;
        if(updateLdapError){
            NotificationManager.error(updateLdapError,"Update Ldap", 3000);
        }
    }

    handleCreateSuccess(){
        const {errorCreateMessage} = this.props; 
        if(errorCreateMessage){
            NotificationManager.error(errorCreateMessage,"Create Ldap", 3000);
        }
        else{
            NotificationManager.success("Ldap Created", "Successfully Created Ldap");
            this.props.history.push("/ldap");
        }
    }

    handleCreateError(){
        const {createLdapError} = this.props;
        if(createLdapError){
            NotificationManager.warning(createLdapError,"Update Ldap", 3000);
        } else {
            NotificationManager.warning("something went wrong!", "Update Ldap");
        }
    }

    submitLdap(userData){
        if (this.props.fromUpdate){
            userData.ldap_id = this.props.ldapId;
            this.props.updateLdap(userData).
                then(() => this.handleUpdateSuccess()).
                catch(() => this.handleUpdateError());
        }
        else {
            this.props.createLdap(userData).
                then(() => this.handleCreateSuccess()).
                catch(() => this.handleCreateError());
        }
    }


    cancelButton(){
        this.props.history.push("/ldap");
    }

    initializeForm(res){
        let currentLdap = res.response.ldap_configs.find(ldap => ldap.ldap_id === this.props.ldapId);
        this.setState({currentLdap: currentLdap});
        this.props.initialize({
            name: currentLdap.name,
            url: currentLdap.url, 
            ldap_id: currentLdap.ldap_id,
            search_filter: currentLdap.search_filter,
            group_membership_filter: currentLdap.group_membership_filter,
            search_base: currentLdap.search_base,
            service_account_dn: currentLdap.service_account_dn,
            service_account_password: currentLdap.service_account_password,
            email_attribute: currentLdap.email_attribute,
            search_subtree: currentLdap.search_subtree,
            auto_create_app_user: currentLdap.auto_create_app_user,
            enabled: currentLdap.enabled,
        });
    }


    componentDidMount(){
        if (this.props.fromUpdate){
            this.props.getLdap().then((res) => this.initializeForm(res)); 
        }
        this.props.getLicenseStatus()
            .then(() => {
                const {license_info} = this.props;
                if (license_info && license_info.status && license_info.status.features && license_info.status.features.indexOf('ldap') >= 0 ){
                    this.setState({licensed: true});
                }
            });
    }

    render(){
        const {handleSubmit} = this.props;
        const {currentLdap} =  this.state;
        const checked = currentLdap && currentLdap.enabled;
        if (!this.state.licensed){
            let license_url = `${__LICENSE_INFO_URL__}`;
            return (
                <Alert color="none" isOpen={true}>
                    <h4>Unavailable</h4>
                    This feature must be licensed.
                    <hr />
                    <a href={license_url}>More Information</a><br/>
                </Alert>
            )
        }
        return (
            <Form onSubmit={handleSubmit(this.submitLdap)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="name" className="requiredasterisk">Name</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="name" 
                                    id="name" 
                                    component={renderField} 
                                    validate={required}
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="url" className="requiredasterisk">Url</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field 
                                    type="url"
                                    name="url" 
                                    id="url" 
                                    component={renderField} 
                                    validate={required}
                                    placeholder="e.g. ldaps://example.local:636"
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="search_base" className="requiredasterisk">Search Base</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="search_base" 
                                    id="search_base" 
                                    component={renderField} 
                                    validate={required}
                                    placeholder="e.g. OU=Employees,DC=example,DC=local"
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="search_filter" className="requiredasterisk">Search Filter</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="search_filter" 
                                    id="search_filter" 
                                    component={renderField} 
                                    validate={required}
                                    placeholder="e.g. sAMAccountName={0}"
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="group_membership_filter" className="requiredasterisk">Group Membership Filter</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="group_membership_filter" 
                                    id="group_membership_filter" 
                                    component={renderField} 
                                    validate={required}
                                    placeholder="e.g &(objectClass=group)(member:1.2.840.113556.1.4.1941:={})"
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="email_attribute">Email attribute</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field 
                                    name="email_attribute" 
                                    id="email_attribute" 
                                    component={renderField} 
                                    placeholder="mail"
                                    autoComplete="off"
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="service_account_dn" className="requiredasterisk">Service Account DN</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="service_account_dn" 
                                    id="service_account_dn" 
                                    component={renderField} 
                                    validate={required}
                                    placeholder="e.g. CN=ldap_bot,CN=Users,DC=example,DC=local"
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col sm="3">
                                <Label htmlFor="service_account_password" className="requiredasterisk">Service Account Password</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field 
                                    name="service_account_password" 
                                    id="service_account_password"
                                    component={renderField} 
                                    validate={required}
                                    autoComplete='random-string'
                                /> 
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="search_subtree">Search Subtree</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="search_subtree">            
                                    <Field name="search_subtree" 
                                        id="search_subtree" 
                                        checked = {checked}
                                        type ="checkbox"
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="auto_create_app_user" className="pull-left">Auto Create App User &nbsp;</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="auto_create_app_user">            
                                    <Field name="auto_create_app_user" 
                                        id="auto_create_app_user" 
                                        checked = {checked}
                                        type ="checkbox"
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup> 
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="enabled" className="pull-left">Enabled &nbsp;</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label check htmlFor="enabled">            
                                    <Field name="enabled" 
                                        id="enabled" 
                                        checked = {checked}
                                        type ="checkbox"
                                        component={renderCheckbox}
                                    />
                                </Label>
                            </Col>
                        </Row>
                    </FormGroup> 
                </CardBody> 

                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="cancel" size="sm" color="basic"
                        className="cancel-button"
                        onClick={() => this.cancelButton()}>Cancel</Button>
                        <Button type="submit" size="sm"
                        className="submit-button"
                        color="primary"> Submit</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}

LdapFormTemplate.propTypes = {
    updateLdap: Proptypes.func.isRequired,
    getLdap: Proptypes.func.isRequired,
    updatErrorWarning: Proptypes.func,
    history: Proptypes.object.isRequired,
    updateLdapError: Proptypes.func,
    createLdapError: Proptypes.func,
    fromUpdate: Proptypes.bool,
    createLdap: Proptypes.func,
    errorCreateMessage: Proptypes.string,
    ldap_configs: Proptypes.array,
    getLdapLoading: Proptypes.bool,
    errorUpdateMessage: Proptypes.string,
    initialize: Proptypes.func,
    handleSubmit: Proptypes.func,
    ldapId: Proptypes.string
};


LdapFormTemplate = reduxForm({ // eslint-disable-line
    form: "LdapFormTemplate" // a unique identifier for this form
})(LdapFormTemplate); // eslint-disable-line

LdapFormTemplate = connect(  // eslint-disable-line
    state => ({
        ldap_configs: state.ldap_configs.ldap_configs || [],
        errorCreateMessage: state.ldap_configs.errorCreateMessage || null,
        updateLdapError: state.ldap_configs.updateLdapError || null,
        getLdapLoading: state.ldap_configs.getLdapLoading || false,
        createLdapError: state.ldap_configs.createLdapError || null,
        initialValues: { enabled: true, auto_create_app_user: true, search_subtree: true },
        license_info: state.footer && state.footer.license_info ? state.footer.license_info : null,
    }),
    dispatch => 
        ({
            updateLdap: (data) => dispatch(updateLdap(data)),   
            getLdap: () => dispatch(getLdap()),
            getLicenseStatus: () => dispatch(getLicenseStatus()),
        })) 
(LdapFormTemplate);  //eslint-disable-line

export default withRouter(LdapFormTemplate);


// WEBPACK FOOTER //
// ./src/views/Ldap/LdapForm/LdapForm.js